<div class="flex flex-col">
  <div
    (click)="emitChartToggleYAxisElement()"
    class="text-s1 flex cursor-pointer select-none flex-row items-start text-lg font-semibold"
  >
    <div class="flex flex-row items-start">
      <m-chevron-right-icon *ngIf="isExpanded === false"></m-chevron-right-icon>
      <m-chevron-down-icon *ngIf="isExpanded === true"></m-chevron-down-icon>

      <div class="ml-2 flex flex-row items-start">
        <div class="text-s1 mb-5"
          >Y Axis {{ yAxisIndex === 0 ? 'Left' : 'Right' }}</div
        >

        <!-- <m-trash-icon
          *ngIf="yAxisIndex !== 0"
          class="ml-5 cursor-pointer text-s500 hover:text-m500 [.group-link:hover_&]:visible"
          (click)="emitChartDeleteYAxisElement($event)"
        ></m-trash-icon> -->
      </div>
    </div>
  </div>

  <div
    *ngIf="isExpanded === true"
    class="mb-5 ml-[32px] flex flex-row items-center"
  >
    <div
      *ngIf="uiChartTypes.yAxis.scale.indexOf(chartType) > -1"
      class="flex max-w-min cursor-pointer flex-row items-center"
      (click)="toggleScale()"
    >
      <div
        class="text-s1 flex h-9 w-[50px] flex-shrink-0 select-none items-center text-base"
        >Scale</div
      >

      <ui-switch
        class="ml-5 mt-1"
        [checked]="yAxisElement.scale"
        color="#64BD63"
      ></ui-switch>
    </div>
  </div>
</div>
